export const RouteConstants = {
  dashboard: "/dashboard",
  login: "login",
  forgotPassword: "forgot-password",
  resetPassword: "reset-password",
  manageNotifications: "/manage-notifications",
  ingredients: "/ingredients",
  recipes: "/recipes",
  newRecipes: "/new-recipes",
  editRecipes: "/edit-recipes",
  newChallenges: "/new-meal-Plan",
  editChallenges: "/edit-meal-Plan",
  challenges: "/meal-Plans",
  products: "/products",
  featured: "/featured",
  fullyFit: "/fully-fit",
  addProduct: "/add-product",
  editProduct: "/edit-product",
  videos: "/videos",
  promotionalOffer: "/promotional-offer",
  addPromotionalOffer: "/add-promotional-offer",
  editPromotionalOffer: "/edit-promotional-offer",
  subscribers: "/subscribers",
  notifications: "/push-notifications",
  users: "/users",
  userDetail: "/users/:id",
  faq: "/faq",
  categories: "/categories",
  reports: "/reports",
  groups: "/groups",
  fullCircle: "/full-circle",
  admins: "/admins",
};
